import { Grid } from '@material-ui/core';
import { OutlinedTextInput, PrimaryButton, Text, TextArea } from 'library';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { client, consoleLogInDev, track } from 'shared';
import { isValidEmail } from 'shared/Validators';
import { useUserContext } from 'UserContext';
import { trackReferralEngagement } from 'api/UserApi';

interface IProps {
    onSubmit: (e: any) => void;
    inviteLink: string;
    referralContext: string;
}
export default function InviteForm({ onSubmit, inviteLink, referralContext }: IProps) {
    const [email, setEmail] = useState('');
    const [validEmail, setValidEmail] = useState(true);
    const [loading, setLoading] = useState(false);
    const { user } = useUserContext();
    const location = useLocation();

    const [message, setMessage] = useState('');
    const validMessage = message.length > 0;

    const validForm = validEmail && validMessage;

    const placeHolderMessage =
        "Hello! I've been using this group on Tandem, and I think you'd love it too. This is a group where we can share providers and discuss our experiences. I hope you'll join!";

    useEffect(() => {
        track('Groups: Invite By Email Form Opened');
        setMessage(placeHolderMessage);
    }, []);

    useEffect(() => {
        validateEmail();
    }, [email]);

    function validateEmail() {
        setValidEmail(isValidEmail(email));
    }

    function handleSend() {
        setLoading(true);
        if (user) {
            trackReferralEngagement(user.id, location.pathname, referralContext)
                .then((response) => {
                    client(`api/group/send-invite-email/`, {
                        body: {
                            message: message,
                            link: `${inviteLink}&reid=${response.id}`,
                            email: email,
                            reid: response.id,
                        },
                    })
                        .catch(consoleLogInDev)
                        .finally(() => {
                            onSubmit(email);
                            setLoading(false);
                        });
                })
                .catch((error) => {
                    consoleLogInDev(error);
                    client(`api/group/send-invite-email/`, {
                        body: {
                            message: message,
                            link: inviteLink,
                            email: email,
                        },
                    })
                        .catch(consoleLogInDev)
                        .finally(() => {
                            onSubmit(email);
                            setLoading(false);
                        });
                });
        }
        if (message === placeHolderMessage) {
            track('Groups: Invite By Email sent with default message');
        } else {
            track('Groups: Invite By Email sent with custom message');
        }
    }

    const EmailField = () => {
        return (
            <Grid container item direction="column">
                <Text variant="body1" bold>
                    Email
                </Text>
                <OutlinedTextInput
                    value={email}
                    defaultValue="email"
                    onChange={(e) => setEmail(e.target.value)}
                    style={{ width: 300 }}
                />
            </Grid>
        );
    };

    const MessageField = () => {
        return (
            <Grid container item direction="column" style={{ paddingTop: 20 }}>
                <Text variant="body1" bold>
                    Message
                </Text>
                <TextArea value={message} onChange={(e) => setMessage(e.target.value)} rows={6} />
            </Grid>
        );
    };

    return (
        <Grid container direction="column" spacing={3}>
            <Grid container item justify="center">
                <Text variant="h1" bold>
                    Invite By Email
                </Text>
            </Grid>
            <Grid container item direction="column">
                {EmailField()}
                {MessageField()}
                <Grid container item justify="flex-end" style={{ paddingTop: 20 }}>
                    <Grid item>
                        <PrimaryButton onClick={handleSend} disabled={!validForm || loading} loading={loading}>
                            Send
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
